import ApiService from './ApiService';

class PortfolioManagerService {
  static async getChangeRequestPanel({ entityType, entityId }) {
    const params = {
      entity: String(entityType),
      entity_id: String(entityId),
    };
    const query = new URLSearchParams(params).toString();
    const composedURL = `/api3/publishable/change-request-panel/?${query}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  /**
   * @param {Record<string, unknown>} body Review payload (entity, entity_id, decision, scope, …).
   * @returns {Promise<unknown>}
   */
  static async postChangeRequestsReview(body) {
    const composedURL = '/api3/publishable/change-requests/review';
    const payload = { ...body };
    if (payload.scope !== 'all') {
      delete payload.panelDataFetchedAt;
      delete payload.panelPendingSnapshot;
      delete payload.rejection_reason;
      if (payload.scope === 'ids') {
        delete payload.sectionKey;
      }
    }
    return ApiService.post(composedURL, payload);
  }
}

export default PortfolioManagerService;
